// Desktop plan page layout with calendar and right rail.
import { Box } from '@mui/material';
import { PANEL_GAP } from '@/components/layout/spacingTokens';
import PlanPageRail from '@/features/planning/components/shared/PlanPageRail';

export function PlanPageDesktopLayout({
  renderView,
  overdueTasks,
  nextActions,
  unscheduledTasks,
  overdueRailSlice,
  nextActionRailSlice,
  selectedTaskIds,
  railSelectionHandlers,
  focusOwnerId,
  planMode,
  planRailTasks,
  plannedParentIds,
  waitingForParentIds,
  tasksMap,
  onboardingHighlightTaskId = null,
  onboardingHighlightAddTask = false,
  onOnboardingAddTaskUsed,
}) {
  return (
    <Box sx={{ flex: 1, display: 'flex', gap: PANEL_GAP, minHeight: 0 }}>
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {renderView()}
      </Box>
      <PlanPageRail
        overdueTasks={overdueTasks}
        nextActions={nextActions}
        unscheduledTasks={unscheduledTasks}
        overdueRailSlice={overdueRailSlice}
        nextActionRailSlice={nextActionRailSlice}
        selectedTaskIds={selectedTaskIds}
        railSelectionHandlers={railSelectionHandlers}
        focusOwnerId={focusOwnerId}
        planMode={planMode}
        planRailTasks={planRailTasks}
        plannedParentIds={plannedParentIds}
        waitingForParentIds={waitingForParentIds}
        tasksMap={tasksMap}
        onboardingHighlightTaskId={onboardingHighlightTaskId}
        onboardingHighlightAddTask={onboardingHighlightAddTask}
        onOnboardingAddTaskUsed={onOnboardingAddTaskUsed}
      />
    </Box>
  );
}
